module.exports = __webpack_public_path__ + "static/media/publicServices.b779d21c.svg";